<script>
export default {
    name: "IconChevronDown",
    props: {
        rotate: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<template>
    <svg class="transition"
         :class="{'rotate-180': rotate}"
         aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
         width="24" height="24" fill="none" viewBox="0 0 24 24">
        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="m19 9-7 7-7-7"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
